module.exports = __webpack_public_path__ + "static/img/医疗.bd63071.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/医疗.png
// module id = Oui/
// module chunks = 3